import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  flex: 1;
  overflow: visible;
`;

export const Image = styled.img<{width?: number; height?: number}>`
  width: ${({width}) => width};
  height: ${({height}) => height};
  overflow: visible;
`;

export const Add = styled.img<{width?: number; height?: number}>`
  width: ${({width}) => width};
  height: ${({height}) => height};
  overflow: visible;
  margin-right: 15px;
`;
